import { Button } from '@shopify/polaris';
import React, { useState, useCallback } from 'react';
import { SearchIcon } from '@shopify/polaris-icons';
import AdvancedProductSearchModal from './modals/advancedProductSearchModal';

export default function ProductSearcherPopover({ value, handleChange, disabled }) {
  const [modalActive, setModalActive] = useState(false);

  const handleAddProducts = useCallback(
    (selectedProducts) => {
      // Pass array of product IDs to handleChange
      if (selectedProducts && selectedProducts.length > 0) {
        const productIds = selectedProducts.map((product) => product.ProductID);
        handleChange(productIds);
      }
    },
    [handleChange]
  );

  return (
    <>
      <Button size="large" disabled={disabled} icon={SearchIcon} onClick={() => setModalActive(true)} />
      <AdvancedProductSearchModal active={modalActive} setActive={setModalActive} onAddProducts={handleAddProducts} disabled={disabled} />
    </>
  );
}
